import 'config/initializer'; // Import all the styles, polyfills, etc.
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';

window.APP_ROOT = document.getElementById('app');
createRoot(window.APP_ROOT).render(
    <App />,
);